import { t as e } from "../utils-DiFe-_ei.js";
import { t } from "../dist-B6xjZgdF.js";
import "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/foundations/badge/badge.tsx
var r = t("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
	variants: { variant: {
		default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
		secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
		destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
		outline: "text-foreground"
	} },
	defaultVariants: { variant: "default" }
});
function i({ className: t, variant: i, ...a }) {
	return /* @__PURE__ */ n("div", {
		className: e(r({ variant: i }), t),
		...a
	});
}
//#endregion
export { i as Badge, r as badgeVariants };

//# sourceMappingURL=badge.js.map